export default __webpack_public_path__ + "static/media/AC-Category-Offer.1596d895.png";